export default "__VITE_ASSET__8lyvchLD__"